import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksRecomendedEquipment(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT].getRegulationsStagesPlanWorksRecomendedEquipment,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}

export default {
	getRegulationsStagesPlanWorksRecomendedEquipment,
}
